




















import Vue from "vue";

// Emits the selected File, or the original image URL when no new file is chosen,
// so the caller can tell a new upload (File) from an unchanged image (string)
export default Vue.extend({
    inheritAttrs: false,
    props: ["value"],
    data() {
        return {
            originalUrl: typeof this.value === "string" ? this.value : null,
            file: this.value instanceof File ? this.value : null,
            filePreviewUrl: null,
        };
    },
    computed: {
        previewUrl() {
            return this.filePreviewUrl || this.originalUrl;
        },
    },
    watch: {
        value(v) {
            if (v instanceof File) {
                return;
            }
            // Value reset from outside (e.g. form reopened for another item)
            this.originalUrl = v || null;
            this.file = null;
            this.revokePreview();
        },
    },
    methods: {
        onChange(file) {
            this.file = file || null;
            this.revokePreview();
            if (this.file) {
                this.filePreviewUrl = URL.createObjectURL(this.file);
            }
            this.$emit("input", this.file || this.originalUrl);
        },
        revokePreview() {
            if (this.filePreviewUrl) {
                URL.revokeObjectURL(this.filePreviewUrl);
                this.filePreviewUrl = null;
            }
        },
    },
    beforeDestroy() {
        this.revokePreview();
    },
});
